// @ts-nocheck
import React from 'react';
import { IconButton, Box } from '@mui/material';
import useCustomForm from 'pages/Forms/context/useCustomForm';
import { DeleteIcon, DownloadIcon } from 'assets/icons';
import { handleDownload, handleRemoveImage } from '../../../AttachmentUtils';

const ImageActions = ({
  photo,
  setImageAttach,
  imageAttach,
  classes,
  handleDirty,
}) => {
  const [{ mode }] = useCustomForm();
  const handleDelete = (e) => {
    e.stopPropagation();
    handleRemoveImage(photo, setImageAttach, imageAttach);
    if (mode === 'add' || mode === 'edit') {
      handleDirty();
    }
  };

  return (
    <Box className={classes.onHover}>
      <p className={classes.imageName}>{photo?.name}</p>
      <Box className={classes.iconButtonContainer}>
        {/* Download icon */}
        <IconButton
          className={classes.actionIconButton}
          aria-label="download"
          onClick={() => {
            handleDownload(photo?.file);
          }}
        >
          <DownloadIcon sx={{ fontSize: '12px' }} />
        </IconButton>
      </Box>
      <Box className={classes.iconButtonContainer}>
        <IconButton
          className={classes.actionIconButton}
          aria-label="delete"
          onClick={handleDelete}
        >
          <DeleteIcon sx={{ fontSize: '12px' }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ImageActions;
